module.exports = __webpack_public_path__ + "a8c1f3beeaf647799724581004e82281.svg";